var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRelay = function SvgRelay(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.2 79.73",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 460.66,
    y1: -120.15,
    x2: 449.39,
    y2: -109.49,
    gradientTransform: "matrix(1 0 0 -1 -389 -47.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#054096",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#173ba1",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3434b3",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#482ec1",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#552bc8",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#592acb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 3.39,
    y1: 42.56,
    x2: 73.6,
    y2: 42.56,
    gradientTransform: "matrix(1 0 0 -1 0 82.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9059ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f770ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 40.92,
    y1: 20.28,
    x2: 81.59,
    y2: 3.07,
    gradientTransform: "matrix(1 0 0 -1 0 82.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54ffbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0df"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.19 18.69l-28.4-16a6.81 6.81 0 00-6.5 0l-28.5 16a6.68 6.68 0 00-3.4 5.8v31.9a6.56 6.56 0 003.4 5.8l28.4 15.9a6.29 6.29 0 003.3.9 6.56 6.56 0 003.3-.9l28.4-15.9a6.68 6.68 0 003.4-5.8v-31.9a6.38 6.38 0 00-3.4-5.8z",
    transform: "translate(-3.39 -1.87)",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 46.92l-1.7 1a2.62 2.62 0 00-1 3.6 2.65 2.65 0 002.3 1.4 3.08 3.08 0 001.3-.3l1.7-1a2.62 2.62 0 001-3.6 2.57 2.57 0 00-3.6-1.1zm10.4-5.9l-3.5 2a2.62 2.62 0 00-1 3.6 2.65 2.65 0 002.3 1.4 3.08 3.08 0 001.3-.3l3.5-2a2.62 2.62 0 001-3.6 2.57 2.57 0 00-3.6-1.1zm14.1-4.89a2.36 2.36 0 00-1.4-1.2V14.82a2.69 2.69 0 00-2.7-2.7 2.61 2.61 0 00-2.6 2.7v20.2a2.36 2.36 0 00-1.4 1.2 2.66 2.66 0 00-.1 2.3 2.66 2.66 0 00.1 2.3 2.36 2.36 0 001.4 1.2v20.2a2.7 2.7 0 005.4 0v-20.3a2.36 2.36 0 001.4-1.2 2.66 2.66 0 00.1-2.3 3.08 3.08 0 00-.2-2.29zm6.81-6.91l-3.5 2a2.62 2.62 0 00-1 3.6 2.65 2.65 0 002.3 1.4 3.08 3.08 0 001.3-.3l3.5-2a2.62 2.62 0 001-3.6 2.57 2.57 0 00-3.6-1.1zm8.29 1a3.08 3.08 0 001.3-.3l1.7-1a2.642 2.642 0 10-2.6-4.6l-1.7 1a2.62 2.62 0 00-1 3.6 2.56 2.56 0 002.3 1.3zm3 17.7l-1.7-1a2.642 2.642 0 00-2.6 4.6l1.7 1a3.08 3.08 0 001.3.3 2.65 2.65 0 002.3-1.4 2.47 2.47 0 00-1-3.5zm-8.7-4.9l-3.5-2a2.642 2.642 0 10-2.6 4.6l3.5 2a3.08 3.08 0 001.3.3 2.65 2.65 0 002.3-1.4 2.45 2.45 0 00-1-3.5zm-27-9.2l3.5 2a3.08 3.08 0 001.3.3 2.65 2.65 0 002.3-1.4 2.62 2.62 0 00-1-3.6l-3.5-2a2.62 2.62 0 00-3.6 1 2.8 2.8 0 001 3.7zm-4.3-8.5l-1.7-1a2.642 2.642 0 10-2.6 4.6l1.7 1a3.08 3.08 0 001.3.3 2.65 2.65 0 002.3-1.4 2.53 2.53 0 00-1-3.5z",
    fill: "#20133a"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRelay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/relay.5e42f204cc953c77e862ea5bab3f9555.svg";